import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { environments } from 'utils/constants';

export const LoggingRedirect = ({ to, origin, ...rest }) => {
    useEffect(() => {
        if (process.env.REACT_APP_ENV !== environments.PROD) {
            if (origin) {
                console.log(`Redirecting from: ${origin}`);
            }
            console.log(`Redirecting to: ${typeof to === 'string' ? to : JSON.stringify(to)}`);
        }
    }, [to, origin]);

    return <Navigate to={to} {...rest} />;
};

LoggingRedirect.propTypes = {
    origin: PropTypes.string.isRequired,
    ...Navigate.propTypes,
};
